import React, { useEffect } from 'react'
import { Button, Input } from '../../components/Form'
import TwoColumRow from '../../components/TwoColumRow'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useDispatch, useSelector } from 'react-redux'
import { getLaboratorios, registrarLaboratorio } from '../../redux/features/laboratorios2Slice'

export const NuevoLaboratorio = ({ onClose }) => {

  const { register, handleSubmit } = useForm()

  const {
    data: laboratorios,
    isLoading: loadingLaboratorios,
    error: errorLaboratorios
  } = useSelector(state => state.laboratorios2)

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getLaboratorios());
  }, [dispatch])


  const onsubmit = async (data) => {
    const { nombreLaboratorio } = data;
    if (nombreLaboratorio.length < 3) {
      toast.error(`el nombre del laboratorio debe tener al menos 3 caracteres`);
      return;
    }
    toast('Inicio el proceso de guardado', {
      icon: '⚠️',
      style: {
        background: '#fff3cd',  // Fondo amarillo suave
        color: '#856404',       // Texto marrón oscuro
        border: '1px solid #ffeeba',
      },
    });

    const newId = laboratorios.length > 0
      ? Math.max(...laboratorios.map(lab => lab.id))
      : 0

    const nuevoLaboratorio = {
      id: (newId + 1),
      nombre: nombreLaboratorio
    }

    try {
      await dispatch(registrarLaboratorio(nuevoLaboratorio)).unwrap();
      toast.success("Laboratorio registrado con éxito")
      onClose();;
    } catch (error) {
      console.error("Error al crear el grupo:", error);
      toast.error(
        `Error al guardar el grupo: ${error.message || JSON.stringify(error)}`
      );
    }
  }

  return (
    <>
      <div className='mb-5'>
        <Input
          label="Nombre del Nuevo Laboratorio"
          placeholder="Nombre del nuevo laboratorio"
          color={true}
          register={register("nombreLaboratorio")}
        // value={grupoNombre}
        // Aunque no uses `register`, puedes manejar el cambio así:
        // register={{
        //   onChange: e => setGrupoNombre(e.target.value),
        //  }}
        />
      </div>
      <TwoColumRow className='mt-5'>
        <Button
          label={"Cancelar"}
          onClick={onClose}
        />
        <Button
          label={`Guardar Laboratorio`}
          onClick={handleSubmit(onsubmit)}
        />
      </TwoColumRow >
    </>
  )
}
